import React from "react";
import { Spinner } from "react-bootstrap";

const Loading = ({ customClass, message }) => {
  return (
    <div className={customClass || "loading-container"}>
      {customClass === "component-loader-3" ||
      customClass === "component-loader-4" ||
      customClass === "line-loader" ? (
        <span className="loader"></span>
      ) : (
        <Spinner
          as="div"
          size="sm"
          role="status"
          animation="border"
          aria-hidden="true"
        />
      )}
      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default Loading;
